import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";

import { PopupPreviewImageComponent } from "src/app/modules/shared/popup-preview-image/popup-preview-image.component";

@Component({
  selector: "app-image-cell-renderer",
  templateUrl: "./image-cell-renderer.component.html",
  styleUrls: ["./image-cell-renderer.component.scss"],
})
export class ImageCellRendererComponent implements OnDestroy {
  params: any;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    params.data.ImageUrl = params.data.ImageUrl
      ? params.data.ImageUrl
      : "assets/images/No_image.png";
    this.params = params;
  }

  previewImage(image) {
    this.dialog
      .open(PopupPreviewImageComponent, {
        width: "400px",
        data: {
          url: image,
          title: this.params.data.Title,
        },
      })
  }

  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
